import React from 'react'
import Banner from './components/Banner'
import { CustomButton } from 'styles/global'
import Navbar from 'components/Navbar'
import { CorpoConteudo } from 'layouts/simple/style'
import { HashLink } from 'react-router-hash-link'
import { scrollWithOffset } from 'util/scrollWithOffset'

const CreditoConsignado = () => {
  return (
    <>
      <Navbar />
      <CorpoConteudo minHeight="calc(100vh - 60px)">
        <Banner
          contentBanner={
            <div className="infos-credito-consignado">
              <div className="container container-produto justify-content-center justify-content-md-between">
                <div className="d-flex flex-column justify-content-center gap-5">
                  <h1>
                    Crédito Consignado com taxas a partir de 1,85%* ao mês.
                  </h1>
                  <h2>
                    Parcele em até 96 vezes com desconto <br /> direto no
                    benefício do INSS.
                  </h2>
                  <ul>
                    <li>Liberação rápida e 100% online</li>
                    <li>Disponível também para negativados</li>
                    <li>Parcelas fixas com desconto direto do benefício</li>
                  </ul>
                  <div className="d-flex justify-content-center w-100">
                    <HashLink
                      to="/#iniciar-simulacao"
                      className="w-100 d-flex justify-content-center no-styled-link"
                      smooth
                      scroll={(el) => {
                        scrollWithOffset(el, 300)
                      }}
                    >
                      <CustomButton
                        background="var(--verde-riber)"
                        borderRadius={25}
                        height="56px"
                        fontSize="30px"
                        maxWidth="300px"
                        width="100%"
                      >
                        Simule agora
                      </CustomButton>
                    </HashLink>
                  </div>
                  <div className="warning">
                    <span>*Para aposentados e pensionistas do inss</span>
                    <b>
                      A riber, não solicita nenhum pagamento antecipado para
                      liberar o seu empréstimo pessoal
                    </b>
                  </div>
                </div>
                <div className="d-lg-flex d-none flex-column justify-content-center">
                  <img
                    className="img-banner-produto"
                    src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/credito_consignado_1.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          }
        />
      </CorpoConteudo>
    </>
  )
}

export default CreditoConsignado
